import api from '@/components/mixins/baseApi';

export default {
  mixins: [api],
  methods: {
    getNewsList() {
      return this.baseAxios({
        method: 'get',
        url: `${this.$store.getters.apiBasePath}/news/page`,
      })
        .then((data) => data || { results: [] })
        .catch((error) => {
          console.log(error);
          return [];
        });
    },
    getNewsItem(id) {
      return this.baseAxios({
        method: 'get',
        url: `${this.$store.getters.apiBasePath}/news/${id}`,
      })
        .then((data) => data.results || null)
        .catch((error) => {
          console.log(error);
          return null;
        });
    },
  },
};
